import './SerialTicketHero.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getMode } from '../../selectors/selectors'

export default function SerialTicketHero() {
  const { t } = useTranslation()
  const mode = useSelector(getMode)

  return (
    <div className="hero">
      <div className="title">{t(`hero.mainTitle.${mode}`)}</div>
      <div className="subtitle" dangerouslySetInnerHTML={{ __html: t(`hero.subtitle.${mode}`) }} />
    </div>
  )
}
